import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { DRAWER_WIDTH, MAIN_CONTENT_TOP } from '../components/Constants'
import { getErrorString } from '../display/ErrorStrings';
import PopupMessage from '../components/PopupMessage'

import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import SubmitIcon from '@material-ui/icons/ArrowDropDownCircleOutlined';

const styles = theme => ({
	root: {
		width: '100%',
		marginTop: theme.spacing.unit * 3,
	},
	tableWrapper: {
		overflowX: 'auto',
		overflowY: 'auto',

		position: 'fixed',
		top: `${MAIN_CONTENT_TOP}px`,
		left: `${DRAWER_WIDTH}px`,
		right: '0px',
		bottom: '0px',
	},
	formContent: {
		marginTop: `50px`,
		position: 'absolute',
		marginLeft: '50px',
		marginRight: '50px',

	},

});

class CreateAccountPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorString: '',
			transit: '',
			account: '',
			billingAccount: '',
			notes: '',
			checkedA: false,
			buttonsDisabled: false,
			warning: false,
			resultTitle: '',
			resultString: '',

		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleTransit = this.handleTransit.bind(this);
		this.handleAccount = this.handleAccount.bind(this);
		this.handleBillingAccount = this.handleBillingAccount.bind(this);
		this.handleNotes = this.handleNotes.bind(this);
		this.handleChecked = this.handleChecked.bind(this);

	}

	componentDidMount() {
		fetch('on_keep_alive',
			{
				method: 'POST',
				credentials: 'same-origin',
				headers:
				{
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(
					{
						'r': new Date().getTime(),
						'secureToken': this.props.secureToken
					}
				)
			})
			.then(function (res) {
				if (!res.ok) {
					throw Error(res.status + " (" + res.statusText + ")");
				}
				return res;
			}).then(res => res.text())
			.then(text => {
				let reply = JSON.parse(text);
				if (reply.authenticated === false) {
					this.props.history.push("/expired")
				}
			})
			.catch(error => {
				this.setState({ errorString: getErrorString('general.server.status.error', 'The server responded with a status of ') + error.message })
			});

	}

	handleSubmit(e) {
		e.preventDefault();
		if (this.props.viewOnly) {
			this.setState({ errorString: getErrorString('viewOnly.warning', 'Operation not allowed in support mode.') });
			return;
		}
		if (this.state.transit == null || this.state.transit === "") {
			this.setState({ errorString: getErrorString('createAccount.transit.error', 'Transit Number is required') });
			return;
		}

		if (this.state.account == null || this.state.account === "") {
			this.setState({ errorString: getErrorString('createAccount.account.error', 'Account Number is required') });
			return;
		}

		if (!this.state.checkedA) {
			this.setState({ errorString: getErrorString('createAccount.checkbox.error', 'Checkbox is not checked') });
			return;
		}
		this.setState({ errorString: '' });
		this.setState({ buttonsDisabled: true });
		this.sendRequest();
	}

	sendRequest() {
		fetch("on_add_account",
			{
				method: 'POST',
				credentials: 'same-origin',
				headers:
				{
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(
					{
						'transit': this.state.transit,
						'account': this.state.account,
						'billingAccount': this.state.billingAccount,
						'notes': this.state.notes,
						'secureToken': this.props.secureToken
					}
				)
			}
		)
			.then(function (res) {
				if (!res.ok) {
					throw Error(res.status + " (" + res.statusText + ")");
				}
				return res;
			}).then(res => res.text())
			.then(text => {
				var reply = JSON.parse(text);
				if (!reply.authenticated) {
					this.props.history.push("/expired")
				}
				else if (reply.error) {
					this.setState({ errorString: reply.errorString })
					this.setState({ buttonsDisabled: false });
				}
				else if (reply.warning) {
					this.setState({ resultString: reply.warningString })
					this.setState({ resultTitle: 'WARNING' })
					this.setState({ warning: true })
				}
				else {
					this.setState({ resultString: 'Your request has been successfully saved. You will be able to access the new account upon our approval.' })
					this.setState({ resultTitle: 'CONFIRMATION' })
				}

			})
			.catch(error => {
				this.setState({ errorString: getErrorString('general.server.status.error', 'The server responded with a status of ') + error.message })
				this.setState({ buttonsDisabled: false });
			});
	}

	handleCancel(e) {
		e.preventDefault();
		this.props.onResult();
	}

	handleTransit(e) {
		this.setState({ transit: e.target.value });
		this.setState({ errorString: '' });
	}

	handleAccount(e) {
		this.setState({ account: e.target.value });
		this.setState({ errorString: '' });
	}

	handleBillingAccount(e) {
		this.setState({ billingAccount: e.target.value });
		this.setState({ errorString: '' });
	}

	handleNotes(e) {
		this.setState({ notes: e.target.value });
		this.setState({ errorString: '' });
	}

	handleChecked(e) {
		this.setState({ checkedA: e.target.checked });
		this.setState({ errorString: '' });
	}

	render() {
		const { classes } = this.props;
		let { t } = this.props;
		return (
			<div className={classes.tableWrapper}>
				{this.state.resultString.length > 0 &&
					<PopupMessage title={this.state.resultTitle} text={this.state.resultString} error={this.state.warning} onClosePopup={this.handleCancel} />
				}

				<div className={classes.formContent}>
					<h3 style={{ color: 'primary' }}> {t('addAccount.label')} </h3>
					<Paper>
						<form className="commentForm" onSubmit={this.handleSubmit}>
							<TextField
								autoFocus
								margin="dense"
								id="transit"
								label={t('transitNumber.label')}
								type="text"
								fullWidth
								required
								onChange={this.handleTransit}
								onKeyPress={event => { return (event.charCode >= 48 && event.charCode <= 57) ? true : event.preventDefault() }}

							/>
							<TextField
								margin="dense"
								id="account"
								label={t('accountNumber.label')}
								type="text"
								fullWidth
								required
								onChange={this.handleAccount}
								onKeyPress={event => { return (event.charCode >= 48 && event.charCode <= 57) ? true : event.preventDefault() }}
							/>
							<TextField
								margin="dense"
								id="billing"
								label={
									<div>
										{t('billingToAccount.label')}
										<span style={{ color: 'primary', fontSize: 10, paddingLeft: 10 }}>{t('leaveBlank.label')}</span>
									</div>
								}
								type="text"
								fullWidth
								onChange={this.handleBillingAccount}
								onKeyPress={event => { return (event.charCode >= 48 && event.charCode <= 57) ? true : event.preventDefault() }}
							/>

							<TextField
								margin="dense"
								id="notes"
								label={t('notes.label')}
								type="text"
								fullWidth
								onChange={this.handleNotes}
							/>

							<FormGroup row>
								<FormControlLabel
									control={
										<Checkbox
											color="primary"
											onChange={this.handleChecked}
										/>
									}
									label={
										<div>
											<p>{t('haveRead.label')}<br />{t('understand.label')}</p>

										</div>
									}
								/>
							</FormGroup>

						</form>
						<Button onClick={this.handleSubmit} color="primary" disabled={this.state.buttonsDisabled}>
							<SubmitIcon />&nbsp;{t('submit.button')}
						</Button>
						<Button onClick={this.handleCancel} color="primary" disabled={this.state.buttonsDisabled}>
							<CancelIcon />&nbsp;{t('cancel.button')}
						</Button>
						{this.state.errorString.length > 0 &&
							<p style={{ color: 'red', paddingLeft: 10 }}> {getErrorString('general.error', 'Error:') + ' ' + this.state.errorString}</p>
						}

					</Paper>

				</div>
			</div>

		);
	}
}
export default withTranslation()(withStyles(styles)(CreateAccountPage));